module.exports = __webpack_public_path__ + "img/28.36c67259.webp";